(function() {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('AccountService', AccountService);

    AccountService.$inject = ['$http', 'API_URL', '$localStorage'];

    function AccountService ($http, API_URL, $localStorage) {
        var service = {
            loadSalutations: loadSalutations,
            loadTitles: loadTitles
        };

        return service;


        function loadSalutations() {
            return $http.get(API_URL + 'salutation', {params:{project:$localStorage.project}});
        }
        function loadTitles() {
            return $http.get(API_URL + 'academictitle', {params:{project:$localStorage.project}});
        }
    }
})();
